import { Link } from "react-router-dom";
import Photo from "../ui/Photo";
import { byTag } from "../../data/salon";
import { duration, finalPrice, toman } from "../../lib/format";
import { useStagger } from "../../lib/motion";
import { SectionHead } from "../ui/Bits";

export default function Signature() {
  const wrap = useStagger({ step: 110 });
  const items = byTag("signature").slice(0, 3);

  return (
    <section className="section section--defer sigs">
      <div className="wrap wrap--wide">
        <SectionHead
          eyebrow="THE SIGNATURES"
          title="کارهایی که <em>رُز</em> با آن شناخته می‌شود"
          lede="سه خدمتی که بیشترین وقت و آموزش رویشان گذاشته‌ایم."
          to="/services"
          toLabel="همه خدمات"
        />

        <div className="sigs__grid" ref={wrap}>
          {items.map((s, i) => (
            <article key={s.id} className={`sig sig--${i} reveal`} data-stagger="">
              <Link to={`/services/${s.slug}`} className="sig__link">
                <div className="sig__media">
                  <Photo src={s.photo} ratio="4 / 5" scrub className="ph--hover" tint="soft" />
                  <span className="sig__index">{`۰${i + 1}`}</span>
                </div>

                <div className="sig__body">
                  <span className="eyebrow eyebrow--violet">SIGNATURE</span>
                  <h3>{s.name}</h3>
                  <p>{s.short}</p>

                  <div className="sig__foot">
                    <span>{toman(finalPrice(s))}</span>
                    <span className="sig__dot" aria-hidden="true" />
                    <span>{duration(s.duration)}</span>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
